module.exports = __webpack_public_path__ + "img/1727164689050-WhatsApp Image 2024-09-24 at 15.57.50.jpeg.ca701a6a.webp";